import type { Edition } from '../../domain/entities/edition.entity';
import type { EditionsApiDatasource } from '../datasources/editions-api.datasource';

export class EditionsRepositoryImpl {
  private readonly api: EditionsApiDatasource;

  constructor(api: EditionsApiDatasource) {
    this.api = api;
  }

  async getEditions(institution: string): Promise<Edition[]> {
    return this.api.getEditions(institution);
  }
}
